import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ETWeatherEventService } from './service';
import { ETEventViewModel } from './interface';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { PlantingRecalculatorService } from '../planting-recalculate-modal/plantingRecalculatorService';
import { RanchWeatherUpdateService } from '../../services/ranch-weather-update.service';

@Component({
	moduleId: module.id,
	selector: 'et-chart',
	templateUrl: 'et-chart.html'
})

export class ETChartComponent implements OnInit, OnDestroy {

	public planting: {
		Id: number,
		Name: string
	};

	public etEvents: ETEventViewModel[];
	public tableHeaders: string[];
	public isLoaded = false;
	public isSaving = false;
	private _subscriptions$: Subject<boolean>;

	constructor(
		public dialogRef: MatDialogRef<ETChartComponent>,
		@Inject(MAT_DIALOG_DATA) private _data: { lotPlantingId: number, name: string },
		private _service: ETWeatherEventService,
		private _plantingRecalculateService: PlantingRecalculatorService,
		private _ranchWeatherUpdateService: RanchWeatherUpdateService
	) {
	}

	ngOnInit(): void {
		this._subscriptions$ = new Subject();

		if (!this._data) {
			throw new Error('ETChartComponent.ngOnInit(): this._data is empty');
		}

		this.planting = {
			Id: this._data.lotPlantingId,
			Name: this._data.name
		};

		// custom click outside behavior
		this.dialogRef.disableClose = true;

		this.dialogRef.backdropClick().pipe(takeUntil(this._subscriptions$)).subscribe(() => {
			if (this.isSaving) {
				this._ranchWeatherUpdateService.showUpdatingNotice();
			}

			this.dialogRef.close();
		});

		this._list();
	}

	ngOnDestroy(): void {
		if (!this._subscriptions$) {
			return;
		}

		this._subscriptions$.next(true);
		this._subscriptions$.complete();
	}

	public save(etEvent: ETEventViewModel): void {
		if (this.isSaving) {
			return;
		}

		if (etEvent.ET === null || etEvent.ET === undefined || etEvent.ET < 0) {
			return;
		}

		if (Number(etEvent.ET) === Number(etEvent.OriginalET)) {
			return;
		}

		this.isSaving = true;

		this._service.save(etEvent).then((res) => {
			if (res && res.Id) {
				etEvent.OriginalET = Number(etEvent.ET);
			}

			this.isSaving = false;
			this._ranchWeatherUpdateService.dismissUpdatingNotice();
			this._plantingRecalculateService.processEventStream(res, this.planting.Id);
		});
	}

	public cancel(): void {
		if (this.isSaving) {
			this._ranchWeatherUpdateService.showUpdatingNotice();
		}

		this.dialogRef.close();
	}

	private _list(): void {

		this._service.list(this.planting.Id).then((response) => {
			if (!response) {
				return;
			}

			this.etEvents = response.ETEvents;
			this.tableHeaders = response.Headers;

			for (let etEvent of this.etEvents) {
				etEvent.OriginalET = etEvent.ET;
			}

			this.isLoaded = true;
		});
	}
}
